export default "__VITE_ASSET__BBiUB0LT__"